import Restriction from "../restriction";
import meshRestrictionHelper from "../meshRestrictionHelper";

class RestrictTree extends Restriction {
    constructor() {
        super({
            type: meshRestrictionHelper.RestrictedMeshTypeEnum.TREE,
            allowedTypesToPopulate: [
                meshRestrictionHelper.RestrictedMeshTypeEnum.TREE,
                meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME
            ]
        });
    }

    _getSelectedBranchIds(branchIds = []) {
        const selectedBranchIds = MeshHierarchyViewFeatureData.getSelectedBranchId();
        if (branchIds.length === 0 && selectedBranchIds.length === 0) return [];

        selectedBranchIds.forEach(branchId => {
            if (!branchIds.includes(branchId)) branchIds.push(branchId);
        });

        return branchIds;
    }

    isValid(branchIds = []) {
        branchIds = this._getSelectedBranchIds(branchIds);

        let invalidBranchIds = [];
        branchIds.forEach(branchId => {
            if (!super.isValid(branchId)) invalidBranchIds.push(branchId);
        });

        if (invalidBranchIds.length > 0) {
            console.error('Restricted branches found: ' + invalidBranchIds);
        }

        return invalidBranchIds.length === 0;
    }

    getPopulatedDataByType(branches, applyTo, mode = meshRestrictionHelper.RestrictionMode.ALLOW_ALL) {
        let data = [];
        let brancheIds = branches.map(branch => branch.id);
        if (mode === meshRestrictionHelper.RestrictionMode.DENY_ALL) {
            brancheIds = [];
            const modelIds = modelManager.getAllModelsId();
            modelIds.forEach(modelId => {
                brancheIds.push(...MeshHierarchyViewFeatureData.getAllBranchIds(modelId));
            });
        }
        if (applyTo === this.type) data = brancheIds;

        brancheIds.forEach(branchId => {
            if (this.allowedTypesToPopulate.includes(applyTo)) {
                data.push(...getDataBasedOnAppliedType(applyTo, branchId));
            }
        });

        return [...new Set(data)];

        function getDataBasedOnAppliedType(type, branchId) {
            let node;
            switch (type) {
                case meshRestrictionHelper.RestrictedMeshTypeEnum.TREE:
                    node = MeshHierarchyViewFeatureData.getDataFromBranchID(branchId);
                    let childNodes = node.getChildNodes();
                    return node ? childNodes.map(node => node.branchID) : [];
                case meshRestrictionHelper.RestrictedMeshTypeEnum.VOLUME:
                    node = MeshHierarchyViewFeatureData.getDataFromBranchID(branchId);
                    return node ? node.getLeaves() : [];
                default:
                    return [];
            }
        }
    }
}

export default RestrictTree;